module.exports = __webpack_public_path__ + "img/website-resource.svg";